// extracted by mini-css-extract-plugin
export default {"usr_btn_skeleton":"UserDetails_usr_btn_skeleton__8ERJ4","use_phone":"UserDetails_use_phone__I0c7g"};